const METERS_IN_MILE = 1609.34;

export function convertMilesToMeters(miles) {
  return miles * METERS_IN_MILE;
}
